import gql from 'graphql-tag';

export const FOOTER_QUERY = gql`
  query FooterNavs {
    footer {
      ...footerFields
      __typename
    }
  }

  fragment footerFields on Footer {
    link {
      text: label
      href: url
      alt
      __typename
    }
    logo {
      url: URL
      media {
        ...uploadFile
      }
      __typename
    }
    copyrightText1
    copyrightText2
    __typename
  }

  fragment uploadFile on UploadFile {
    id
    createdAt
    updatedAt
    name
    alternativeText
    caption
    width
    height
    formats
    hash
    ext
    mime
    size
    url
    webPURL
    previewUrl
    provider
    __typename
  }
`;

export default FOOTER_QUERY;
